// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
const PropTypes = require('prop-types');
// @ actions
const cancelCreditCardRenewalActions = require('actions/contactCenter/creditCardRenewalInfo');

// @ components
const CancelCreditCardRenewal = require('components/contactCenter/cancelCreditCardRenewal/cancelCreditCardRenewal');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const CancelCreditCardRenewalErrorStep = require('components/contactCenter/cancelCreditCardRenewal/cancelCreditCardRenewalErrorStep');
const CancelCreditCardRenewalSuccessStep = require('components/contactCenter/cancelCreditCardRenewal/cancelCreditCardRenewalSuccessStep');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const pageTitle = formatText('accountModifyStep-pageTitle');

const { NO_RENOVAR } = require('constants/index');

class CancelCreditCardRenewalView extends React.Component {
    constructor(props) {
        super(props);
        this.beforeLeaving = this.beforeLeaving.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }


    isReady() {
        const { immCreditCardRenewalStatus } = this.props;
        !immCreditCardRenewalStatus.get('isFetching');
    }


    beforeLeaving() {
        const { immCreditCardRenewalStatus } = this.props;
        if (immCreditCardRenewalStatus.get('submitSuccessful') && immCreditCardRenewalStatus.get('willLeave')) {
            this.props.immCreditCardRenewalStatus.reset();
        }
    }

    buildError() {
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        return (
            <CancelCreditCardRenewalErrorStep
                immCard={immCard}
            />
        );
    }

    buildSuccessful() {
        const { match: { params: { cardId } }, immCards, immCreditCardRenewalStatus } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const renewalStatus = immCreditCardRenewalStatus.getIn(['cancelRenewalDetails', 'descripcionSituaTarjeta']);
        return (
            <CancelCreditCardRenewalSuccessStep
                immCard={immCard}
                renewalStatus={renewalStatus}
            />
        );
    }

    buildWizard() {
        const { match: { params: { cardId } }, cancelRenewal, immCards, immCreditCardRenewalStatus, setVisibleStep, validateStep, setWillCancel } = this.props;
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const immCard = immCards.get('byId').get(cardId);

        return (
            <div className="row no-outside-gutter">
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isReady}
                    beforeLeaving={this.beforeLeaving}
                    onConfirmLeave={this.handleConfirmLeave}
                />
                <CancelCreditCardRenewal
                    immCard={immCard}
                    cancelRenewal={cancelRenewal}
                    immCreditCardRenewalStatus={immCreditCardRenewalStatus}
                    setVisibleStep={setVisibleStep}
                    validateStep={validateStep}
                    setWillCancel={setWillCancel}
                    cardId={cardId}
                />
            </div>
        );
    }

    render() {
        let content;
        const { match: { params: { cardId } }, immCards, immCreditCardRenewalStatus } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const submitSuccessful = immCreditCardRenewalStatus.get('submitSuccessful');
        const errorReceived = immCreditCardRenewalStatus.get('error');
        const renewalStatus = immCreditCardRenewalStatus.getIn(['cancelRenewalDetails', 'descripcionSituaTarjeta']);

        const confirmationMessage = renewalStatus.toUpperCase() === NO_RENOVAR ? 'activateRenewalLink' : 'statusLink';
        const mappingBreadcrumb = [
            {
                text: formatText('accountModifyStep-pageTitle'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText(`creditRenewal-${confirmationMessage}`),
                url: ''
            }
        ]

        if (submitSuccessful) {
            content = this.buildSuccessful();
        } else if (errorReceived) {
            content = this.buildError();
        } else {
            content = this.buildWizard();
        }

        return (
            <section className="keys-view">
                <OKHeaderCC
                    title={pageTitle}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className="keys-view__container">
                    <div className="col-xs-12">
                        {content}
                    </div>
                </div>
            </section>
        );
    }
}


CancelCreditCardRenewalView.propTypes = {
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    immCreditCardRenewalStatus: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    isReady: PropTypes.func,
    cancelRenewal: PropTypes.func,
    match: PropTypes.object.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
};

module.exports.constructor = CancelCreditCardRenewalView;
module.exports.CancelCreditCardRenewalView = connect(
    state => ({
        immCreditCardRenewalStatus: state.cancelCreditCardRenewal,
        immCards: state.cards
    }), {
    setVisibleStep: cancelCreditCardRenewalActions.setVisibleStep,
    validateStep: cancelCreditCardRenewalActions.validateStep,
    cancelRenewal: cancelCreditCardRenewalActions.cancelRenewal,
    setWillCancel: cancelCreditCardRenewalActions.setWillCancel,
    reset: cancelCreditCardRenewalActions.reset,
})(CancelCreditCardRenewalView);
